module.exports = __webpack_public_path__ + "img/13.b065f4ac.png";